var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'app': true,
    'locked': _vm.fullscreen,
    'cefEvent': _vm.cefEvent,
    'iosFront': _vm.isIosView,
    'is-mobile': _vm.isMobile
  },attrs:{"id":"app"}},[(_vm.userLoggedIn)?_c('BatteryMonitor'):_vm._e(),_c('UserMediaConnector'),_c('AuthManager'),_c('UserProfileContainer'),(_vm.isLanguageControllerEnabled)?_c('LanguageController'):_vm._e(),(_vm.userLoggedIn && !_vm.isCefOrIosView)?_c('LegalUpdatePrompt'):_vm._e(),(!_vm.isSupportedBrowserAndSystem)?_c('BrowserCheck'):_vm._e(),(_vm.showRouter)?_c('div',{staticClass:"base-content",class:{'user-logged-in': _vm.userLoggedIn}},[_c('router-view')],1):_vm._e(),_c('portal-target',{attrs:{"name":"app"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }